import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBuilding = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 19.51h18M7.836 8.921H8.7m-.864 3.323H8.7m-.864 3.323H8.7M15.775 13.352h.864m-.864 3.323h.864M12.26 19.51V6.368c0-1.038-.841-1.878-1.878-1.878H6.153c-1.037 0-1.878.84-1.878 1.878v13.14"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.814 19.509v-7.327c0-1.037-.84-1.877-1.877-1.877h-5.678v9.204"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBuilding);
export default ForwardRef;
